import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Text from "components/Text";

import { IPackageDetailsField } from "entities/Checklist/sdk";

import PrintableMemoFieldTitle from "../PrintableMemoFieldTitle";

interface IPrintableRichtextfield {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableRichtextfield = ({
  field,
  isNASection,
}: IPrintableRichtextfield) => {
  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  return (
    <Box sx={{ borderBottom: `1px solid ${colors.blue40}` }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <PrintableMemoFieldTitle field={field} disabled={isNAField} />

        <Stack direction="row" alignItems="center" gap={1}>
          {isNAField && (
            <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
              N/A
            </Text>
          )}
        </Stack>
      </Stack>
      <Box
        sx={{
          flex: 1,
          "@media print": {
            "*": { lineHeight: "140% !important" },
            table: {
              width: "100%",
            },
            "table, th, td, tr": {
              borderCollapse: "collapse",
              border: "1px solid black !important",
            },
          },
        }}
      >
        {!isNAField && (
          <SanitizeHtml
            html={_.first(field.values)?.rich_value! || "N/A"}
            dataTestid="field-value"
          />
        )}
      </Box>
    </Box>
  );
};

export default PrintableRichtextfield;
